import { render, staticRenderFns } from "./BreadcrumbNavigation.vue?vue&type=template&id=223ea337"
import script from "./BreadcrumbNavigation.vue?vue&type=script&lang=js"
export * from "./BreadcrumbNavigation.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {ArrowLeftIcon: require('/vercel/path0/components/icons/ArrowLeftIcon.vue').default,ChevronRightIcon: require('/vercel/path0/components/icons/ChevronRightIcon.vue').default})
